import { RegisterError } from './reducer/registerReducer';
import { FormattedMessage } from 'react-intl';
import { Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { FunctionBuilder } from '@xolv-mybrightlink/common';
import { contactLink } from '../common/ContactLink';

export const RegisterErrorMessage = (props: { errorCode: RegisterError }) => {
  const navigate = useNavigate();
  return (
    <Typography variant='body2' color={'error'}>
      <FunctionBuilder>
        {() => {
          switch (props.errorCode) {
            case 'bad-credentials':
              return <FormattedMessage id={'signup.error.invalid-token'} />;
            case 'rate-limited':
              return <FormattedMessage id={'auth.otp.resend.limit-exceeded'} />;
            case 'already-signed-up':
              return (
                <FormattedMessage
                  id={'signup.error.already-signed-up'}
                  values={{ contactLink }}
                />
              );
            case 'client-existed':
              return (
                <FormattedMessage
                  id={'signup.error.client-existed'}
                  values={{ contactLink }}
                />
              );
            case 'not-match':
              return (
                <FormattedMessage
                  id={'signup.error.not-match'}
                  values={{ contactLink }}
                />
              );
            case 'duplicated':
              return (
                <FormattedMessage
                  id={'signup.error.duplicated-user'}
                  values={{
                    signIn: (text) => (
                      <Link
                        onClick={() => navigate(-1)}
                        sx={{
                          fontWeight: 500,
                        }}
                      >
                        {text}
                      </Link>
                    ),
                  }}
                />
              );
            case 'generic-error':
              return (
                <FormattedMessage
                  id={'common.error.generic.rich'}
                  values={{ contactLink }}
                />
              );
          }
        }}
      </FunctionBuilder>
    </Typography>
  );
};
